// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3AVfK","row":"Node_row__1Mzmk","label":"Node_label__1OTN8","footer":"Node_footer__fvtzT"};